const restaurant = {
  restaurant: "Restaurant", // translated
  restaurants: "Restaurants", // translated
  category: "Categorie", // translated
  score: "Scoren", // translated
  priceQuartile: "Prijs kwartiel", // translated
  scoreLowestFirst: "Score (laagste eerst)", // translated
  scoreHighestFirst: "Score (hoogste eerst)", // translated
  priceLowestFirst: "Prijs: laagste eerst)", // translated
  priceHighestFirst: "Prijs: hoogste eerst)", // translated
  allPrices: "Alle prijzen", // translated
  reserve: "Reserveren", // translated
  dining: "Dineren", // translated
};


export default restaurant;
